export default __webpack_public_path__ + "static/media/logo.660856c2.png";